import React from 'react';
import {Label} from 'reactstrap';
import FormRadio from '../../components/Common/FormRadio';

const SERVICE_OPTIONS = [
  {type: '50k, 150k, 250k etc. Service', part: 'N40002086', name: 'GTX600SB PREVENT. MAINTENANCE 50K/150K/250K KIT'},
  {type: '100k, 300k, 500k etc. Service', part: 'N40002087', name: 'GTX600SB PREVENT. MAINTENANCE 100K/300K/500K KIT'},
  {type: '200k, 400k, 600k etc. Service', part: 'N40002088', name: 'GTX600SB PREVENT. MAINTENANCE 200K/400K/600K KIT'},
];

const Gtx600sbServices = () => {
  return (
    <>
      <Label htmlFor="service_type" className="col-form-label">
        Choose a service *
      </Label>

      {SERVICE_OPTIONS.map(({type, part, name}) => {
        return (
          <div
            key={type}
            className={`service-option mb-2 form-control`}
          >
            <FormRadio
              name="service_type"
              label={type}
              value={type}
            />
            <p className="mb-0 pl-4">
              {name}
              <br/>
              <span className="text-yellow">{part}</span>
            </p>
          </div>
        );
      })}
    </>
  );
};

export default Gtx600sbServices;
